<div class="pl-3" class="left-border ml-5">
    <div class="row align-items-center mb-2 ml-2">
        <div class="col-lg-3 col-12">
            <label><strong>Creative Theme
                <span class="text-danger">*</span>
            </strong></label>
        </div>
        <div class="col-lg-9 col-12">
            <p-dropdown class="mr-0 pr-0" [style]="{width: '90%'}" (onChange)="setCreativeTheme($event)" *ngIf="!reviewPage && campaign.campaignStatusId == 1" autoWidth="false" [(ngModel)]="creative.detailSocialCampaignJson.creativeTheme" [options]="creativeThemeDD"></p-dropdown>
            <label *ngIf="reviewPage || campaign.campaignStatusId != 1" class="mr-0 pr-0">{{creativeThemeLabel}}</label>
        </div>
    </div>

    <div class="row align-items-center mb-2 ml-2" *ngIf="creativeThemeLabel == 'Other'">
        <div class="col-lg-3 col-12">
            <label><strong>Other Creative Theme
                <span class="text-danger">*</span>
            </strong></label>
        </div>
        <div class="col-lg-9 col-12 input-box">
            <input class="form-control" *ngIf="!reviewPage && campaign.campaignStatusId == 1" type="text" [(ngModel)]="creative.detailSocialCampaignJson.otherCreativeThemeText" [title]="creative.detailSocialCampaignJson.otherCreativeThemeText" style="overflow: hidden; text-overflow: ellipsis;">
            <label *ngIf="reviewPage || campaign.campaignStatusId != 1" class="mr-0 pr-0">{{creative.detailSocialCampaignJson.otherCreativeThemeText}}</label>
        </div>
    </div>

    <div class="row align-items-center mb-2 ml-2">
        <div class="col-lg-3 col-12">
            <label><strong>Client Provided Creative
                <span class="text-danger">*</span>
            </strong></label>
        </div>
        <div class="col-lg-5 col-12">
            <div *ngIf="!reviewPage && campaign.campaignStatusId == 1" class="d-flex align-items-center" style="margin-left: -25px;">
                <div class="custom-control custom-radio custom-control-inline">
                    <input type="radio"  id="clientProvidedCreativeYes" name="clientProvidedCreative" [(ngModel)]="creative.detailSocialCampaignJson.clientProvidedCreative" class="p-radiobutton mr-2 custom-control-input" [value]="true">
                    <label class="custom-control-label red" for="clientProvidedCreativeYes">Yes</label>
                </div>
                <div class="custom-control custom-radio custom-control-inline">
                    <input type="radio"  id="clientProvidedCreativeNo" name="clientProvidedCreative" [(ngModel)]="creative.detailSocialCampaignJson.clientProvidedCreative" class="p-radiobutton mr-2 custom-control-input" [value]="false">
                    <label class="custom-control-label red" for="clientProvidedCreativeNo">No</label>
                </div>
            </div>
            <label *ngIf="reviewPage || campaign.campaignStatusId != 1" class="mr-0 pr-0">{{creative.detailSocialCampaignJson.clientProvidedCreative ? 'Yes' : 'No'}}</label>
        </div>
        
    </div>

    <div class="mb-4" [ngClass]="isApprove? 'col-8':'col-4'">
        <file-upload (openPreviewEvent)="openPreview($event)" [reviewPage]='reviewPage' [isApprovedReported]='creative.creativeAssets[sponsorLogoAssetIndex]?.isValid!=null' [isApprove]='isApprove' filetypes="jpg, jpeg, png, gif" [footer]='booleanFalse' [header]="booleanTrue" [headerTitle]="'Sponsor logo'" [campaign]="campaign" [creative]="creative" [asset]="sponsorLogoAssetIndex" [showRequired]="!sponsorLogoRequired" (onAssetDelete)="removeAsset($event)"></file-upload>

        <file-upload [reviewPage]='reviewPage' [bulkUpload]="booleanTrue" filetypes="all" [header]="booleanTrue" [campaign]="campaign" [creative]="creative" [headerTitle]="'Asset'" (onAssetDelete)="removeAsset($event)" [showRequired]="sponsorLogoRequired"></file-upload>

        <div *ngFor="let item of creative.creativeAssets; let i = index">
            <div *ngIf="!!item.file && !!item.fileName && i !== sponsorLogoAssetIndex">
                <label class="my-0 font-weight-bold pl-3 mr-3">{{item.fileName}}</label>
                <i *ngIf="campaign.campaignStatusId == enumCampaignStatus.Assets_Pending" (click)="removeAsset(item)" class="fa fa-trash-alt delete" pTooltip='Remove asset'></i>
            </div>
        </div>
    </div>
</div>